<template>
    <Card :bordered="false" class="border-radius-0" :key="data.useForm.modelRef?.id">
        <CardBorder :title="$t('views.section.requestDetail')">
            <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldOriginal"
                                 :skeleton="isLoading"></TemplateBuilder>
                <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldRequestDetails"
                                 :skeleton="isLoading">
                </TemplateBuilder>
                <!-- force render tab because need validate all tab -->
                <!-- eslint-disable-next-line vue/no-mutating-props -->
                <Tabs v-model:activeKey="menuContext.tabKeyRequester" type="card" class="mt-3" :tabBarStyle="{ paddingLeft: '11.4em !important' }">
                    <TabPane key="Requester" :forceRender="true">
                        <template v-slot:tab>
                            <CIcon file="user-transfer.svg"></CIcon>
                            {{ $t("views.request.licenseRequest.transferRequester") }}
                        </template>
                        <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldRequester" :skeleton="isLoading">
                        </TemplateBuilder>
                    </TabPane>
                    <TabPane key="Assignee" :forceRender="true">
                        <template v-slot:tab>
                            <CIcon file="connection.svg"></CIcon>
                            {{ $t("views.request.licenseRequest.assignee") }}
                        </template>
                        <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldAssignee" :skeleton="isLoading">
                        </TemplateBuilder>
                    </TabPane>
                </Tabs>
            </Form>
            <!-- force render tab because need validate all tab -->
            <!-- eslint-disable-next-line vue/no-mutating-props -->
            <Tabs v-model:activeKey="menuContext.tabKey" type="card" class="mt-3">
                <TabPane key="Vessel" :forceRender="true" v-if="data.previewVesselRequestAttachment?.length > 0">
                    <template v-slot:tab>
                        <CIcon file="fishing-boat.svg"></CIcon>
                        {{ $t("views.vessel.title") }}
                    </template>
                    <VesselForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        dataKey="refVesselRequest"
                        :isLoading="isLoading"
                        itemsKey="refVesselRequest"
                    ></VesselForm>
                </TabPane>
                <TabPane key="VesselOwner" :forceRender="true">
                    <template v-slot:tab>
                        <CIcon file="fisher-man.svg"></CIcon>
                        {{ $t("views.vesselOwner.title") }}
                    </template>
                    <VesselOwnerList
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        :isLoading="isLoading"
                        dataKey="refVesselRequest"
                        itemsKey="vesselOwnerRequests"
                    ></VesselOwnerList>
                </TabPane>
                <TabPane key="FishingTool" :forceRender="true">
                    <template v-slot:tab>
                        <CIcon file="fishing-tool.svg"></CIcon>
                        {{ $t("views.fishingTool.title") }}
                    </template>
                    <FishingToolList
                        :menuContext="menuContext"
                        :viewOnly="true"
                        :dataProp="data"
                        :isLoading="isLoading"
                        itemsKey="fishingToolRequests"
                    ></FishingToolList>
                </TabPane>
                <TabPane key="Attachment" :forceRender="true">
                    <template v-slot:tab>
                        <CIcon file="folder.svg"></CIcon>
                        {{ $t("views.attachment.title") }}
                    </template>
                    <AttachmentForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        :isLoading="isLoading"
                        group="LicenseRequestAttachment"
                    ></AttachmentForm>
                </TabPane>
                <TabPane key="FeeStatement" v-if="data.useForm.modelRef?.feeStatements?.length">
                    <template v-slot:tab>
                        <CIcon file="active.svg"></CIcon>
                        {{ `${$t("views.feeStatement.tabTitle")} (${data.useForm.modelRef?.refPaymentStatus?.value || ""})` }}
                    </template>
                    <FeeStatementRequestForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        :isLoadingProp="isLoading"
                        itemsKey="feeStatements"
                    ></FeeStatementRequestForm>
                </TabPane>
            </Tabs>
        </CardBorder>

        <CardBorder :title="$t('views.section.officerAudit')"
                    v-if="![undefined, 'draft'].includes(data.useForm?.modelRef?.refStatus?.key)">
            <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldOfficerConsider"
                                 :skeleton="isLoading"></TemplateBuilder>
            </Form>
            <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldLawyerConsider"
                                 :skeleton="isLoading"></TemplateBuilder>
            </Form>
            <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldDofCenterConsider"
                                 :skeleton="isLoading"></TemplateBuilder>
            </Form>
            <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldDirector"
                                 :skeleton="isLoading"></TemplateBuilder>
            </Form>
            <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldCancelRequest"
                                 :skeleton="isLoading"></TemplateBuilder>
            </Form>
        </CardBorder>
        <CardBorder :title="$t('views.section.appellant')" v-if="['notApprove', 'appeal'].includes(data.useForm?.modelRef?.refStatus?.key) || data.useForm?.modelRef?.isHaveAppealedRequest">
            <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldAppealRequest"
                                 :skeleton="isLoading"></TemplateBuilder>
            </Form>
        </CardBorder>
        <ChangeLogCollapse
            class="mt-2"
            v-if="visibleChangeLog && data.id"
            :id="data.id"
            :onCallChangeLog="({ id, page, size }) => onCallChangeLog({ id, page, size, createSearchOneCriteria, callChanges })"
            :mappings="data.fieldLogs"
        ></ChangeLogCollapse>
    </Card>
</template>

<script>
import { Card, Form, Tabs } from "ant-design-vue";
import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
import { useRoute } from "vue-router";
import { state as stateApp } from "../../../../../app.logic";
import { createFormTitle, initForm, isLoading, onClickModalOk, callChanges, createSearchOneCriteria } from "./transfer-license.logic";
import { state } from "../request.logic";
import { onCallChangeLog } from "../../../../../utils/form";

export default defineComponent({
    components: {
        Card,
        Form,
        Tabs,
        TabPane: Tabs.TabPane,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder")),
        VesselForm: defineAsyncComponent(() => import("../../vessel/VesselForm")),
        VesselOwnerList: defineAsyncComponent(() => import("../../vessel-owner/VesselOwnerList")),
        FishingToolList: defineAsyncComponent(() => import("../../fishing-tool/FishingToolList")),
        AttachmentForm: defineAsyncComponent(() => import("../../attachment/AttachmentForm")),
        FeeStatementRequestForm: defineAsyncComponent(() => import("../../../fee-statement/request/RequestForm")),
        CardBorder: defineAsyncComponent(() => import("../../../../../components/card/CardBorder")),
        CIcon: defineAsyncComponent(() => import("../../../../../components/icon/CIcon")),
        ChangeLogCollapse: defineAsyncComponent(() => import("../../../../../components/change-log/ChangeLogCollapse")),
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "transfer-license-requests" },
        licenseType: {},
        viewOnly: { default: false },
        form: {},
        setAppPageHeader: { default: true },
        visibleChangeLog: { default: true },
        forceDefault: { default: false },
        isRouteFromMyJob: { default: false },
    },
    setup(props) {
        // eslint-disable-next-line vue/no-mutating-props
        const route = useRoute();
        const id = props.form ? props.form.id : route.params?.id;
        const data = reactive({
            rowProp: { gutter: 24 },
            id,
            fieldLogs: [],
            sendReceive: false,
            tabRequester: "Requester",
        });
        const refs = reactive({ form: null });
        initForm({ props, data, refs, route });
        const callOnClickModalOk = () => onClickModalOk({ data, refs });
        const title = computed(() => createFormTitle({ data }));
        return {
            props,
            data,
            refs,
            state,
            title,
            isLoading,
            callOnClickModalOk,
            callChanges,
            createSearchOneCriteria,
            onCallChangeLog,
        };
    },
});
</script>
